
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fotobox-mieten-hochzeit",
      function () {
        return require("private-next-pages/fotobox-mieten-hochzeit.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fotobox-mieten-hochzeit"])
      });
    }
  